import { ForgeRadio } from '@tylertech/forge-react';
import React, { FormEvent, FunctionComponent } from 'react';
import { RowCountDisplay, RowCountType } from 'common/providers/RowCount';
import isEmpty from 'lodash/fp/isEmpty';
import { fetchTranslation } from 'common/locale';

const t = (key: string) => fetchTranslation(key, 'shared.explore_grid.export_dataset_modal');

export interface FilterRadioButtonProps {
  selectedFiltered: boolean;
  handleRadioFilterChange: (selectedFiltered: boolean) => void;
  showFilteredDataOption: boolean;
  odata?: boolean;
}

const FilteringRadioButtons: FunctionComponent<FilterRadioButtonProps> = ({
  selectedFiltered,
  odata = false,
  showFilteredDataOption,
  handleRadioFilterChange,
}) => {
  const onHandleRadioFilterChange = (event: FormEvent) => {
    const target = event.target as HTMLInputElement;
    const isSelectedFiltered = target.value !== 'all';
    handleRadioFilterChange(isSelectedFiltered);
  };

  return (
    <div
      className="filtered-radio-group"
      data-testid="radio-group-filtering"
      role="radiogroup"
      aria-label={t('dialog_radio')}
    >
      {showFilteredDataOption && !odata && (
        <ForgeRadio
          className="filtered-data"
          id="radio-filtered"
          name="radio-filters"
          data-testid="radio-option-filtered"
          value="filtered"
          onClick={onHandleRadioFilterChange}
          checked={selectedFiltered}
        >
          <RowCountDisplay
            countType={RowCountType.Filtered}
            label={isEmpty(window.STORY_DATA) ? 'modified_data' : 'filtered_data'}
          />
        </ForgeRadio>
      )}
      <ForgeRadio
        className="all-data"
        id="radio-all"
        name="radio-filters"
        data-testid="radio-option-all"
        value="all"
        onClick={onHandleRadioFilterChange}
        checked={!selectedFiltered}
      >
        <RowCountDisplay countType={RowCountType.Total} label="all_data" />
      </ForgeRadio>
    </div>
  );
};

export default FilteringRadioButtons;
